import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation deleteUcceMrd($id: ID!) {
  deleteUcceMrd(id: $id){
    id
  }
}`;

function deleteUcceMrd(id) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
    },
  }).then((res) => res.data.deleteUcceMrd);
}

export default deleteUcceMrd;
